import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Recovery from "@/components/Recovery";
import ClaimForm from "@/components/ClaimForm";
import About from "@/components/About";
import Consult from "@/components/Consult";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="relative min-h-screen bg-ink text-cream">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Recovery />
          <ClaimForm />
          <About />
          <Consult />
          <Faq />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
